import { Routes, Route } from "react-router-dom";

import { routes } from "./routes";
import Home from "./pages/Home/Home";
import Playground from "pages/Playground/Playground";
import { styles } from "styles";

function App() {
  return (
    <div style={styles.container}>
      <Routes>
        <Route path={routes.home} element={<Home />} />
        <Route path={routes.playground} element={<Playground />} />
      </Routes>
    </div>
  );
}

export default App;
